import {
  workOrderDetailQueryKey,
  workOrderStockIssueCandidatesQueryKey,
} from '#/utils/queryKeys';

export async function invalidateWorkOrderOutboundQueries(queryClient, workOrderId) {
  if (!workOrderId) {
    return;
  }

  await queryClient.invalidateQueries({
    queryKey: workOrderDetailQueryKey(workOrderId),
  });
  await queryClient.invalidateQueries({
    queryKey: workOrderStockIssueCandidatesQueryKey(workOrderId),
  });
}
